import React from 'react';
import styled from 'styled-components';

const StyledFixedBox = styled.div`
    position: fixed;
    top: ${props => props.top};
    bottom: ${props => props.bottom};
    left: ${props => props.left};
    right: ${props => props.right};
    width: ${props => props.width ? props.width : '100%'};
    height: ${props => props.height};
    padding: ${({ padding }) => padding};
    background: ${({ background }) => background};
    color: ${({ color}) => color};
`;

const StyledCover = styled(StyledFixedBox).attrs({
    width: "calc(100% - 360px)"
})`
    background-image: ${({ img }) => `url(${img})`};
    background-repeat: no-repeat;
    background-attachment: local;
    background-position: center;
    background-size: cover;
`;

const Cover = (props) => {
    return <StyledCover {...props} />
};

const FixedBox = (props) => {
    return <StyledFixedBox {...props} />
};

const StyledFixedFlexBox = styled(FixedBox)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
`;

const FixedFlexBox = (props) => <StyledFixedFlexBox { ...props } />

export { FixedBox };
export { FixedFlexBox };
export { Cover };